import React, { useState } from "react";
import { useOpticDump } from "@/hooks/useOptic";
import { Loading } from "@/components/common/Loading";

export function DumpLoader({ opticId, hasDump }: { opticId: string; hasDump: boolean }) {
  const [enabled, setEnabled] = useState(false);
  const { data, isLoading, error } = useOpticDump(opticId, enabled);

  if (!hasDump) {
    return <p className="text-textLight text-sm">No raw dump for this run.</p>;
  }

  if (!enabled) {
    return (
      <button
        onClick={() => setEnabled(true)}
        className="px-md py-xs rounded-md bg-info-bg text-info-text text-sm font-medium hover:bg-info-bg/80"
      >
        Load raw dump (~600 KB)
      </button>
    );
  }

  if (isLoading) return <Loading label="Loading raw dump…" />;
  if (error) return <p className="text-danger-text text-sm">Failed to load dump.</p>;
  if (!data) return null;

  const baselinePreview = data.baseline.slice(0, 24);

  function download() {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `optic-dump-${opticId}.json`;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="space-y-sm">
      <button
        onClick={download}
        className="px-md py-xs rounded-md bg-surface border border-border text-sm hover:bg-bg"
      >
        Download full JSON
      </button>
      <div className="rounded-md border border-border bg-surface p-sm text-xs text-textLight">
        <div>baseline length: {data.baseline.length}</div>
        <div>cycles: {data.cycles.length} × {data.cycles[0]?.length ?? 0}</div>
        <div className="mt-xs font-mono">
          first 24 baseline values:&nbsp;
          {baselinePreview.map(v => (v == null ? "·" : v)).join(", ")}…
        </div>
      </div>
    </div>
  );
}
